export const _en = {
    materialResource: {
        alert: "The session \"{{activityName}}\" of the training course \"{{courseName}}\" does not have an associated material resource."
    },
    humanResource: {
        alert: "The session \"{{activityName}}\" of the training course \"{{courseName}}\" does not have an associated human resource."
    },
    materialResourceNeeded: {
        alertNeed: "The session \"{{planningName}}\" of the training course \"{{courseName}}\" has unmet material resource requirements.",
        customAlertNeed: "The session \"{{planningName}}\" of the training course \"{{courseName}}\" has unmet material resource requirements\n{{choice}}."
    },
    humanResourceNeeded: {
        alertNeed: "The session \"{{planningName}}\" of the training course \"{{courseName}}\" has unmet human resource needs.",
        customAlertNeed: "The session \"{{planningName}}\" of the training course \"{{courseName}}\" has unmet human resource needs\n{{choice}}."
    },
    neededResourceRespected: {
        alertNeedRespected: "The resource \"{{resourceName}}\" assigned to the session \"{{planningName}}\" of the course \"{{courseName}}\" does not meet the resource requirements. Please verify the resource's consistency.",
        alertNeedNotRespectedOnDate: "The resource “{{resourceName}}” positioned on the session “{{planningName}}” of the training course “{{courseName}}” no longer has valid skill(s)”."
    },
    simulatorRessourceValidated: {
        alertValidated: "The simulator \"{{simulatorName}}\" is not validated by the DGAC."
    },
    materialResourceCapacity: {
        alertCapacity: "The material resource \"{{resourceName}}\" has a capacity less than the number of people planned for the session \"{{planningName}}\"."
    },
    RegulatoryDuration: {
        course: {
            alertRegulatory: "The theoretical duration of the training course “{{courseName}}” must be less than or equal to the regulatory duration of the training course."
        },
        product: {
            alertRegulatory: "The theoretical duration of the training course model “{{courseName}}” must be less than or equal to the regulatory duration of the training course model."
        }
    },
    syllabusDayDurationValidity: {
        course: {
            normalDuration: "The number of days required {{dayNeeded}} for the training course \"{{courseName}}\" is greater than the regulatory duration {{courseDuration}}.",
            regulatorDuration: "The number of days required {{dayNeeded}} for the training course \"{{courseName}}\" is greater than the regulatory duration {{regulatorDuration}}."
        },
        product: {
            normalDuration: "The number of days required {{dayNeeded}} for the training course model \"{{productName}}\" is greater than the regulatory duration {{productDuration}}.",
            regulatorDuration: "The number of days required {{dayNeeded}} for the training course model \"{{productName}}\" is greater than the regulatory duration {{regulatorDuration}}."

        }
    },
    startEndHourValidity: {
        course: {
            session: {
                alertStartValidity: "The start date of the session “{{planningName}}” does not respect the time constraints of the module “{{moduleName}}” on the date {{moduleStartDate}}.",
                alertEndValidity: "The end date of the session “{{planningName}}” does not respect the time constraints of the module “{{moduleName}}” on the date {{moduleFinishDate}.",
                course: {
                    alertStartValidity: "The start time of the session “{{planningName}}” does not respect the time constraints of the training course “{{courseName}}” at “{{courseStartHour}}.",
                    alertEndValidity: "The end time of the session “{{planningName}}” does not respect the time constraints of the training course “{{courseName}}” at “{{courseEndHour}}."
                }
            },
            module: {
                alertStartValidity: "The start time of the module \"{{moduleName}}\" does not respect the start time of the training course \"{{courseName}}\" at {{courseStartHour}}.",
                alertEndValidity: "The duration of the module  \"{{moduleName}}\" does not respect the default duration of the module within the stage \"{{courseName}}\" of {{courseModuleDuration}}."
            }
        },
        product: {
            module: {
                alertStartValidity: "The start time of the module \"{{moduleName}}\" does not respect the start time of the training course template \"{{productName}}\" at {{productStartHour}}.",
                alertEndValidity: "The end time of the module \"{{moduleName}}\" does not respect the end time of the training course \"{{productName}}\" at {{productEndHour}}."
            },
            activity: {
                alertStartValidity: "The start time of the session \"{{activityName}}\" does not respect the time constraints of the module \"{{moduleName}}\" at {{moduleStartHour}}.",
                alertEndValidity: "The end time of the session \"{{activityName}}\" does not respect the time constraints of the module \"{{moduleName}}\" at {{moduleEndHour}}.",
                product: {
                    alertStartValidity: "The start time of the session \"{{activityName}}\" does not respect its stage pattern \"{{productName}}\" at {{productStartHour}}.",
                    alertEndValidity: "The end time of the session \"{{activityName}}\" does not respect its stage pattern \"{{productName}}\" at {{productEndHour}}."
                }
            }
        }
    },
    dateSessionCheck: {
        alertDateSession: "The session \"{{planningName}} ({{sessionTime}})\" is not scheduled on the same day as the module \"{{moduleName}}\" on {{moduleDate}}."
    },
    startEndHourForSimulatorSession: {
        course: {
            session: {
                associated: {
                    startHour: "The session “{{planningName}}” is in a simulator and does not respect the expected {{scale}} minute(s) timing for its start time ({{sessionStartHour}})."
                },
                needed: {
                    startHour: "The session “{{planningName}}” has a simulator requirement and does not respect the expected “{{scale}}” minute(s) timing for its start time ({{sessionStartHour}})."
                }

            }
        }
    },
    interSessionAlert: {
        alertInterSession: "The assignment of the resource \"{{resourceName}}\" to the session \"{{planningName}}\" is invalid and does not respect the inter-session time of {{interSessionTime}} minute(s)."
    }
};

export const _fr = {
    materialResource: {
        alert: "L'activité «<i> <b>{{activityName}}</b></i> » du stage «<i> <b>{{courseName}}</b></i> » ne dispose pas de ressource matérielle associée."
    },
    humanResource: {
        alert: "L'activité «<i> <b>{{activityName}}</b></i> » du stage «<i> <b>{{courseName}}</b></i> » ne dispose pas de ressource humaine associée."
    },
    materialResourceNeeded: {
        alertNeed: "L'activité «<i> <b>{{planningName}}</b></i> » du stage «<i> <b>{{courseName}}</b></i> » dispose de besoins en ressource matérielle non remplis.",
        customAlertNeed: "L'activité «<i> <b>{{planningName}}</b></i> » du stage «<i> <b>{{courseName}}</b></i> » dispose de besoins en ressource matérielle non remplis\n{{choice}}."
    },
    humanResourceNeeded: {
        alertNeed: "L'activité «<i> <b>{{planningName}}</b></i> » du stage «<i> <b>{{courseName}}</b></i> » dispose de besoins en ressource humaine non remplis.",
        customAlertNeed: "L'activité «<i> <b>{{planningName}}</b></i> » du stage «<i> <b>{{courseName}}</b></i> » dispose de besoins en ressource humaine non remplis\n{{choice}}."
    },
    neededResourceRespected: {
        alertNeedRespected: "La ressource «<i> <b>{{resourceName}}</b></i> » positionnée sur la séance «<i> <b>{{planningName}}</b></i> » du stage «<i> <b>{{courseName}}</b></i> » ne correspond pas au besoin en ressource. Veuillez vérifier la cohérence de la ressource.",
        // a confirmer le message
        alertNeedNotRespectedOnDate: "La ressource «<i> <b>{{resourceName}}</b></i> » positionnée sur la séance «<i> <b>{{planningName}}</b></i> » du stage «<i> <b>{{courseName}}</b></i> » ne dispose plus de(s) compétence(s) valide(s)</b></i> »."
    },
    simulatorRessourceValidated: {
        alertValidated: "Le simulateur «<i> <b>{{simulatorName}}</b></i> » n'est pas validé par la DGAC."
    },
    materialResourceCapacity: {
        alertCapacity: "La ressource matérielle «<i> <b>{{resourceName}}</b></i> » possède une capacité inférieure au nombre de personnes prévues sur la séance «<i> <b>{{planningName}}</b></i> »."
    },
    RegulatoryDuration: {
        course: {
            alertRegulatory: "La durée théorique du stage «<i> <b>{{courseName}}</b></i> » doit être inférieure ou égale à la durée règlementaire du stage."
        },
        product: {
            alertRegulatory: "La durée théorique du modèle de stage «<i> <b>{{courseName}}</b></i> » doit être inférieure ou égale à la durée règlementaire du modèle de stage."
        }
    },
    syllabusDayDurationValidity: {
        course: {
            normalDuration: "La durée des jours nécessaires {{dayNeeded}} pour le stage «<i> <b>{{courseName}}</b></i> » est supérieure à la durée reglementaire {{courseDuration}}.",
            regulatorDuration: "La durée des jours nécessaires {{dayNeeded}} pour le stage «<i> <b>{{courseName}}</b></i> » est supérieure à la durée reglementaire {{regulatorDuration}}."
        },
        product: {
            normalDuration: "La durée des jours nécessaires {{dayNeeded}} pour le modèle de stage «<i> <b>{{productName}}</b></i> » est supérieure à la durée reglementaire {{productDuration}}.",
            regulatorDuration: "La durée des jours nécessaires {{dayNeeded}} pour le modèle de stage «<i> <b>{{productName}}</b></i> » est supérieure à la durée reglementaire {{regulatorDuration}}."

        }
    },
    startEndHourValidity: {
        course: {
            session: {
                alertStartValidity: "La date de début de la séance «<i> <b>{{planningName}}</b></i> » ne respecte pas les contraintes horaires du module «<i> <b>{{moduleName}}</b></i> » à la date {{moduleStartDate}}.",
                alertEndValidity: "La date de fin de la séance «<i> <b>{{planningName}}</b></i> » ne respecte pas pas les contraintes horaires du module «<i> <b>{{moduleName}}</b></i> » à la date {{moduleFinishDate}.",
                course: {
                    alertStartValidity: "L'heure de début de la séance «<i> <b>{{planningName}}</b></i> » ne respecte pas les contraintes horaires du stage «<i> <b>{{courseName}}</b></i> » à «<i> <b>{{courseStartHour}}.",
                    alertEndValidity: "L'heure de fin de la séance «<i> <b>{{planningName}}</b></i> » ne respecte pas les contraintes horaires du stage «<i> <b>{{courseName}}</b></i> » à «<i> <b>{{courseEndHour}}."
                }
            },
            module: {
                alertStartValidity: "L'heure de début du module «<i> <b>{{moduleName}}</b></i> » ne respecte pas l'heure de debut du stage «<i> <b>{{courseName}}</b></i> » à {{courseStartHour}}.",
                alertEndValidity: "La durée du module «<i> <b>{{moduleName}} ne respecte pas la durée par défaut du module au sein du stage «<i> <b>{{courseName}}</b></i> » de {{courseModuleDuration}}."
            }
        },
        product: {
            module: {
                alertStartValidity: "L'heure de début du module «<i> <b>{{moduleName}}</b></i> » ne respecte pas l'heure de debut du modèle de stage «<i> <b>{{productName}}</b></i> » à {{productStartHour}}.",
                alertEndValidity: "L'heure de fin du module «<i> <b>{{moduleName}}</b></i> » ne respecte pas l'heure de fin du stage {{productName}}</b></i> » à {{productEndHour}}."
            },
            activity: {
                alertStartValidity: "L'heure de début de l'activité «<i> <b>{{activityName}}</b></i> » ne respecte pas les contraintes horaires du module «<i> <b>{{moduleName}}</b></i> » à {{moduleStartHour}}.",
                alertEndValidity: "L'heure de fin de l'activité «<i> <b>{{activityName}}</b></i> » ne respecte pas les contraintes horaires du module «<i> <b>{{moduleName}}</b></i> » à {{moduleEndHour}}.",
                product: {
                    alertStartValidity: "L'heure de début de l'activité «<i> <b>{{activityName}}</b></i> » ne respecte pas son modèle de stage «<i> <b>{{productName}}</b></i> » à {{productStartHour}}.",
                    alertEndValidity: "L'heure de fin de l'activité «<i> <b>{{activityName}}</b></i> » ne respecte pas son modèle de stage «<i> <b>{{productName}}</b></i> » à {{productEndHour}}."
                }
            }
        }
    },
    dateSessionCheck: {
        alertDateSession: "La séance «<i> <b>{{planningName}} ({{sessionTime}})</b></i> » n'est pas planifiée dans le même jour que le module «<i> <b>{{moduleName}}</b></i> » le {{moduleDate}}."
    },
    startEndHourForSimulatorSession: {
        course: {
            session: {
                associated: {
                    startHour: "La séance «<i> <b>{{planningName}}</b></i> » à un simulateur et ne respecte pas le calage de {{scale}} minute(s) attendu pour son heure de début ({{sessionStartHour}})."
                },
                needed: {
                    startHour: "La séance «<i> <b>{{planningName}}</b></i> » à un besoin de simulateur et ne respecte pas le calage de «<i> <b>{{scale}}</b></i> » minute(s) attendu pour son heure de début ({{sessionStartHour}})."
                }

            }
        }
    },
    interSessionAlert: {
        alertInterSession: "L'affectation de la ressource «<i> <b>{{resourceName}}</b></i> » à la séance «<i> <b>{{planningName}}</b></i> » est invalide et ne respecte pas le temps d'inter-séance de {{interSessionTime}} minute(s)."
    }
};